var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("w-select", {
    attrs: {
      items: _vm.languageItems,
      label: _vm.label,
      fancy: _vm.fancy,
      disabled: _vm.disabled,
    },
    model: {
      value: _vm.selectedLanguage,
      callback: function ($$v) {
        _vm.selectedLanguage = $$v
      },
      expression: "selectedLanguage",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }